'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Header = function (props) {
    var back = props.back, onBackButtonClick = props.onBackButtonClick, backIcon = props.backIcon, title = props.title, className = props.className;
    return (React__default['default'].createElement("div", { className: "login__forms__header " + className },
        back && onBackButtonClick &&
            React__default['default'].createElement("div", { className: 'login__forms__header__back', onClick: onBackButtonClick }, backIcon || React__default['default'].createElement("i", { className: 'lifepal__icon lifepal__icon--arrow-left-blue' })),
        React__default['default'].createElement("p", null, title || 'Selamat Datang')));
};

exports.Header = Header;
//# sourceMappingURL=Header.js.map
